<template>
  <ContentView>
    <b-modal
      v-model="isModalActive"
      has-modal-card
      trap-focus
      aria-role="dialog"
      aria-label="ChoseEtablissementModal"
      :aria-modal="true"
      scroll="keep"
      class="ChoseEtablissementView"
      @close="cancelProjectCreation"
    >
      <div class="modal-card">
        <header class="modal-card-head">
          <H3TitleView class="modal-card-title"
            >{{ $t("myProjects.create-project.title").toString() }}
          </H3TitleView>
          <button
            type="button"
            class="delete"
            aria-label="close"
            @click="cancelProjectCreation"
          ></button>
        </header>
        <section class="modal-card-body">
          <EtablissementSelectionView
            v-model="chosenEtablissement"
            :enable-back="false"
            :button-label="$t('myProjects.create-project.choseEtablissement')"
            :show-speech="false"
            :input-label="$t('myProjects.create-project.etablissementChoice')"
            :show-bottom-buttons="false"
            @etablissement-selected="setChosenEtablissement"
            @update:model-value="setChosenEtablissement"
          />
        </section>
        <footer class="modal-card-foot">
          <div class="buttons">
            <div class="modal-finish-buttons">
              <div class="hoverable-discrete-link" @click="cancelProjectCreation">
                {{ $t("annuler") }}
              </div>
              <b-button
                rounded
                type="is-primary"
                :disabled="!chosenEtablissement || !chosenEtablissement.codeEtablissement"
                @click="submit"
              >
                {{ $t("myProjects.nextStep") }}
              </b-button>
            </div>
          </div>
        </footer>
      </div>
    </b-modal>
  </ContentView>
</template>

<script lang="ts">
import { defineComponent } from "vue"
import ContentView from "@/views/commons/ContentView.vue"
import EtablissementSelectionView from "@/views/login/registration/EtablissementSelectionView.vue"
import H3TitleView from "@/views/commons/H3TitleView.vue"
import { EtablissementDTO } from "@/model/bean/GeneratedDTOs"
import { BButton, BModal } from "buefy"

export default defineComponent({
  name: "ChoseEtablissementView",
  components: {
    ContentView,
    EtablissementSelectionView,
    H3TitleView,
    BButton,
    BModal,
  },

  emits: ["etablissement-chosen", "cancel-project-creation"],
  data() {
    return {
      chosenEtablissement: undefined as unknown as EtablissementDTO,
      isModalActive: true,
    }
  },
  mounted() {
    this.isModalActive = true
  },
  methods: {
    setChosenEtablissement(etablissement: EtablissementDTO): void {
      this.chosenEtablissement = etablissement
    },

    submit(): void {
      this.$emit("etablissement-chosen", this.chosenEtablissement)
    },

    cancelProjectCreation(): void {
      this.$emit("cancel-project-creation")
    },
  },
})
</script>

<style lang="scss">
@import "@/styles/variables";

.ChoseEtablissementView {
  .modal-card {
    height: $create-project-modals-height;
    overflow-y: auto !important;
  }
}
</style>
